import React, { useState } from "react";
import { Camera, Play } from "lucide-react";
import { isVideo } from "../mediaModel";

// Visual for one media item: the real file from storage (an <img>, or a <video>
// showing its first frame), over the gallery's warm placeholder gradient — which
// is all that shows if the file cannot be loaded. Reused by the gallery, the
// Knowledge city view and the Journey Detail media list.
export default function MediaThumb({ item, large = false }) {
  const video = isVideo(item);
  const [broken, setBroken] = useState(false);
  const Icon = video ? Play : Camera;
  const showFile = Boolean(item.file_url) && !broken;

  return (
    <div className={`tsp-media-visual tsp-media-tone-${item.id % 4} ${large ? "is-large" : ""}`}>
      {showFile && !video && <img src={item.file_url} alt={large ? item.caption : ""} loading="lazy" onError={() => setBroken(true)} />}
      {showFile && video && (
        <video src={item.file_url} controls={large} muted={!large} playsInline preload="metadata" aria-label={large ? item.caption : undefined} onError={() => setBroken(true)} />
      )}
      <span className="tsp-media-type-badge" title={video ? "Video" : "Photo"}>
        <Icon size={large ? 16 : 13} />
        <span className="tsp-sr-only">{video ? "Video" : "Photo"}</span>
      </span>
      {broken && <span className="tsp-sr-only">This file could not be loaded</span>}
    </div>
  );
}
